import actions from './actions'
import mutations from './mutations'

const codes = {
    namespaced: true,
    state: {
        referralCodes: [],
        isLoaded: false,
        pagination: {
            page: 1,
            length: null,
            total: null
        }
    },
    mutations,
    actions
}

export default codes
